import script from "./deliveryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./deliveryTable.vue?vue&type=script&setup=true&lang=js"

import "./deliveryTable.vue?vue&type=style&index=0&id=1d906102&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d906102"]])

export default __exports__